
// Returns a point by its original index, before sorting by date.
export default function getPoint(series, index) {
  return series.find(item => item.index === index);
}



// WEBPACK FOOTER //
// ./src/chart/data/getPoint.js